import { Box, Pressable } from "native-base";
import * as React from "react";
import { Text, View } from "react-native";
import Colors from "../../const/Colors";
import { API } from "../../api/types";

interface BarDateProps {
  item: API.BarDateItem[];
  onPressItem: (item: API.BarDateItem) => void;
}

const BarDate = ({ item, onPressItem }: BarDateProps) => {
  return (
    <Box
      id={"BarDate"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      // backgroundColor={'purple.200'}
      paddingX={"4px"}
    >
      <Box
        key={"-1"}
        // width={20}
        justifyContent={"center"}
        alignItems={"center"}
        // backgroundColor={'yellow.50'}
      >
        <View
          style={{
            borderRadius: 100,
            width: 32,
            height: 32,
            backgroundColor: Colors.transparent,
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          <Text
            style={{
              fontSize: 16,
            }}
          ></Text>
        </View>
      </Box>

      {item.map((value, index) => {
        return (
          <Box
            key={index}
            // width={20}
            justifyContent={"center"}
            alignItems={"center"}
            // backgroundColor={'yellow.50'}
          >
            <Pressable onPress={() => onPressItem(value)}>
              <View
                style={{
                  borderRadius: 100,
                  width: 32,
                  height: 32,
                  backgroundColor: value.isPicked
                    ? Colors.ammChartDot
                    : Colors.transparent,
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 0,
                }}
              >
                <Text
                  style={{
                    fontSize: 16,
                  }}
                >
                  {value.text}
                </Text>
              </View>
            </Pressable>
          </Box>
        );
      })}
    </Box>
  );
};

export default BarDate;
